import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { COMMON_MESSAGES } from 'src/app/messages';
import { RoleTypes } from 'appRootPath/models/commercial-papers.model';

@Component({
  selector: 'app-reject-modal',
  templateUrl: './reject-modal.component.html',
  styleUrls: ['./reject-modal.component.scss']
})
export class RejectModalComponent implements OnInit {
  @Input() userRole: RoleTypes;
  rejectionForm: FormGroup;
  documentsList;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.documentsList = this.parseDocumentsList(this.userRole);

    this.rejectionForm = this.parseRejectionForm(this.documentsList);
  }

  /**
   * Based on the role type of the user, returns the list of documents.
   * @param userRole - Role type of the user.
   */
  parseDocumentsList(userRole: RoleTypes) {
    return [
      {
        id: 'letter_of_offer',
        name: 'Letter Of Offer',
        is_valid_for_current_user: userRole === 'investor' ? false : true,
        isRejected: false
      },
      {
        id: 'deal_confirmation_note',
        name: 'Deal Confirmation Note',
        is_valid_for_current_user: true, // This document is valid for every user.
        isRejected: userRole === 'investor' ? true : false
      },
      {
        id: 'promissory_note',
        name: 'Promissory Note',
        is_valid_for_current_user: userRole === 'ipa' ? true : false,
        isRejected: false
      },
      {
        id: 'rbi_letter',
        name: 'RBI Letter',
        is_valid_for_current_user: userRole === 'ipa' ? true : false,
        isRejected: false
      },
      {
        id: 'covering_letter',
        name: 'Covering Letter',
        is_valid_for_current_user: userRole === 'ipa' ? true : false,
        isRejected: false
      },
      {
        id: 'eligibility_letter',
        name: 'Eligibility Letter',
        is_valid_for_current_user: userRole === 'ipa' ? true : false,
        isRejected: false
      }
    ];
  }

  /**
   * Returns the Reject Form controls. Filters out invalid documents for current user.
   * @param documentsList - List of documents for rejection.
   */
  parseRejectionForm(documentsList) {
    return this.formBuilder.group({
      comments: [null, Validators.required],
      rejected_documents: this.formBuilder.array(
        documentsList
          .filter(doc => Boolean(doc.is_valid_for_current_user))
          .map(document => {
            return this.formBuilder.group({
              ...document
            });
          }))
    });
  }


  /**
   * Handles the reject button click.
   * @param rejectionFormData - Rejection Form value.
   */
  onRejectClick(rejectionFormData) {
    if (!rejectionFormData.comments) {
      this.toastr.warning(COMMON_MESSAGES.REJECT_REASON_MISSING);
    } else if (this.userRole !== 'investor' && !rejectionFormData.rejected_documents.filter(d => Boolean(d.isRejected)).length) {
      this.toastr.warning(COMMON_MESSAGES.REJECTED_DOCUMENTS_MISSING);
    } else {
      this.activeModal.close(rejectionFormData);
    }
  }
}
